<template>
  <div id="gifts">
    <!-- 礼包列表 -->
    <ul
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      infinite-scroll-immediate-check="false"
      class="list"
    >
      <li
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div class="img-box">
          <img src="@/static/images/home/pic_list.png" />
        </div>
        <div class="info">
          <div class="title">
            <span class="tip">{{ item.brand }}</span> {{ item.name }}
          </div>
          <p>有效期至：{{ item.period }}</p>
          <p>兑换比例：{{ item.ratio }}%</p>
          <div class="ctrl">
            <p class="contain">面值：{{ item.amount }}</p>
            <div class="btn">
                <mt-button size="large" type="primary" class="grey" v-show="item.periodState == 1" >已过期</mt-button>
              <mt-button size="large" type="primary" @click="use(item)" v-show="item.periodState == 0"  >使用</mt-button>
            </div>
          </div>
        </div>
      </li>

      <li>
        <div class="loading" v-show="loading">
          <mt-spinner type="fading-circle"></mt-spinner>
          <p>加载中...</p>
        </div>
        <div class="loading" v-show="loadAll">
          <p>已加载全部</p>
        </div>
      </li>
    </ul>
    <NoData v-show="noData" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      list: [], //礼包列表
      loading: false,
      loadAll: false,
      noData: false,
      pageNo: "1",
      pageSize: "10",
    };
  },
  mounted() {
    this.queryTicketList();

  },
  methods: {
    //查询我的礼包列表接口 queryTicketList
    queryTicketList(fn) {
      this.post(this.apis.queryTicketList, {
       memberId: this.userInfo.memberId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        weixinId: this.openIdKey,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.list = [...this.list, ...response.data.list];
            if (fn) {
              fn();
            }

            if (response.data.list.length == 0 && this.pageNo != 1) {
              this.loadAll = true;
            }
            if (!this.loadAll && response.data.list.length == 0) {
              this.noData = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toDetail(item) {
      this.$router.push({ name: "GiftDetail", params: { id: item.id } });
    },
    use(item) {
      console.log("toDetail -> item", item);
    },
    loadMore() {
      if (this.loadAll) {
        return;
      }
      this.loading = true;
      this.pageNo++;
      this.queryTicketList(() => {
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapState(["openIdKey","userInfo"]),
  },
};
</script>

<style lang="less" scoped>
#gifts {
  .list {
    padding: 30px 30px 0;
    margin: 0 auto;
    .item {
      width: 691px;
      height: 240px;
      background-color: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(163, 163, 163, 0.45);
      border-radius: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 26px;
      .img-box {
        flex: 0 0 187px;
        height: 170px;
        display: flex;
        align-items: center;
        margin-left: 18px;
        margin-right: 18px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .info {
        height: 186px;
        .title {
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: #3a3a3a;
          font-size: 30px;
          width: 440px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .tip {
            display: inline-block;
            padding: 0 10px;
            margin-right: 10px;
            background-color: #1fbe6e;
            border-radius: 4px;
            font-family: PingFang-SC-Regular;
            font-size: 24px;
            line-height: 42px;
            color: #fff;
            text-align: center;
          }
        }
        p {
          padding-top: 10px;
          font-family: PingFang-SC-Regular;
          color: #3a3a3a;
        }
        .ctrl {
          width: 450px;
          p {
            padding-top: 0;
            &.contain {
              flex: 0 0 300px;
            }
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 64px;
          .btn {
            .mint-button--large {
              width: 160px;
              height: 53px;
            }
            .grey{
              background: grey;
            }
          }
        }
      }
    }
  }
}
</style>
